module.exports = __webpack_public_path__ + "static/img/report_img_gbaqsc.f93551d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/report_img_gbaqsc.png
// module id = sNZo
// module chunks = 21